import Link from "next/link";
import Arrow2Icon from "../../../public/img/cheersup-v2/arrow2.svg";
import LicenceIcon from "../../../public/img/cheersup-v2/licence.svg";
import RecordIcon from "../../../public/img/cheersup-v2/record.svg";
import DiscordIcon from "../../../public/img/cheersup-v2/discord.svg";
import OpenseaIcon from "../../../public/img/cheersup-v2/opensea.svg";
import {
  CHEERS_UP_DISCORD_URL,
  CHEERS_UP_OPENSEA_COLLECTION_NAME,
} from "@/constants/index";
import { getNftCollectionUrl } from "@/utils/util";
import classNames from "classnames";

const LinkItem = ({ text, link, icon, extraIcon = null }) => {
  return (
    <Link
      href={link}
      target="_blank"
      className="group relative w-[228px] h-[228px] lg:w-[242px] lg:h-[242px] xl:w-[290px] xl:h-[290px] rounded-[40px] bg-white flex flex-col text-black transition hover:text-white hover:bg-[#395AFF] ml-[8px] first:ml-0 even:mt-[50px]"
    >
      <div className="flex-1 flex items-center justify-center scale-[0.6] lg:scale-[0.8] xl:scale-100">
        {icon}
      </div>

      <div className="h-[64px] border-0 border-t-2 border-solid border-black flex items-center justify-center  group-hover:border-white">
        <div className="font-bold">{text}</div>
        <Arrow2Icon className="ml-[4px] mt-[-1px]" />
      </div>

      {extraIcon}
    </Link>
  );
};

export const Links = () => {
  return (
    <div className="flex items-center mt-[100px] pt-[96px] relative">
      <div
        className={classNames(
          "absolute z-0 origin-top-right h-full w-full bg-no-repeat bg-right-top bg-[url(/img/cheersup-v2/link-bg.png)] bg-contain",
          "scale-[0.7] top-[30px]",
          "lg:scale-[0.8] lg:top-[20px]",
          "xl:scale-100 xl:top-[-20px]"
        )}
      ></div>

      <div className="flex justify-around mx-auto">
        <LinkItem
          text={"Licence Guide".toUpperCase()}
          link="/licence-guide"
          icon={
            <LicenceIcon className="w-[112px] transition group-hover:text-white" />
          }
        />

        <LinkItem
          text={"Provenance Record".toUpperCase()}
          link="/provenance-record"
          icon={
            <RecordIcon className="w-[112px] transition group-hover:text-white" />
          }
        />

        <LinkItem
          text={"Join our Discord".toUpperCase()}
          link={CHEERS_UP_DISCORD_URL}
          icon={
            <DiscordIcon className="w-[112px] transition group-hover:text-white" />
          }
        />

        <LinkItem
          text={"Buy on OpenSea".toUpperCase()}
          link={getNftCollectionUrl(CHEERS_UP_OPENSEA_COLLECTION_NAME)}
          icon={
            <OpenseaIcon className="w-[112px] transition group-hover:text-white" />
          }
        />
      </div>
    </div>
  );
};
